<template>
  <div class="daypicker-card">
    <div class="list-holder" :class="{ 'combi-order': combiOrder }">
      <h3 v-if="type === 'deliver'">Bezorgmoment</h3>
      <h3 v-else-if="type === 'pickup'">Ophaalmoment</h3>
      <h3 v-else>Afhaalmoment</h3>
      <p class="combi-title" v-if="combiOrder">Printen op maat:</p>

      <ul class="date-selection">
        <li
          v-for="date in dates"
          :key="date.date"
          :class="{
            selected: date.date === activeDate.date,
            active: date.active,
            inactive: !date.active
          }"
          @click="setDate(date)"
        >
          <div>
            <p class="text" v-if="date.title === 'vandaag'">Van-<br />daag</p>
            <p class="text" v-else-if="date.title === 'morgen'">
              Mor-<br />gen
            </p>
            <p class="date" v-else>
              <span class="day">{{ date.day.substring(0, 2) }}</span>
              <span class="nr">{{ date.date }}</span>
            </p>
          </div>
        </li>
      </ul>

      <div class="spoed-holder" v-if="type != 'pickup'">
        <spec-button
          :title="'Spoed'"
          :selected="activeDate.value === 'spoed'"
          @action="setSpoed"
          class="spoed-btn"
        ></spec-button>

        <p v-if="activeDate.value === 'spoed'" class="system-text spoed-text">
          {{
            custom.deliveryTime && custom.deliveryTime.urgentText
              ? custom.deliveryTime.urgentText
              : 'Wij nemen contact met u op.'
          }}
        </p>
      </div>
    </div>
    <div class="ps-text" v-if="combiOrder">
      <p class="title">Signing:</p>
      <span>
        Bezorging binnen 3 werkdagen
      </span>
    </div>
  </div>
</template>

<script>
/**
 * Daypicker component
 *
 * Properties:
 * - dates - Array of dates
 * - activeDate - selected date
 */
import SpecButton from './SpecButton.vue'

export default {
  props: ['dates', 'activeDate', 'type', 'combiOrder'],
  emits: ['setDate', 'set-date'],
  components: {
    SpecButton
    // Datepicker
  },
  methods: {
    setSpoed() {
      let date = {}
      if (this.activeDate.title === 'spoed') {
        date = this.dates.find((adate) => adate.active)
      } else {
        date = {
          value: 'spoed',
          title: 'spoed',
          day: 'spoed',
          time: 'spoed',
          times: [
            {
              time: 'spoed'
            }
          ]
        }
      }
      this.$emit('setDate', date)
    },
    setDate(date) {
      if (date.active) {
        this.$emit('setDate', date)
      }
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/base/_colors.scss' as *;

.list-holder {
  //box-shadow: var(--default-shadow);
  //border-radius: 20px;
  //  padding: 15px;
}

.daypicker-card {
  box-shadow: var(--default-shadow);
  border-radius: 25px;
  padding: 20px;
  margin: -10px;
}

.combi-order h3 {
  padding-bottom: 10px;
}

.combi-title {
  margin-bottom: 10px;
  font-weight: 500;
}
h3 {
  padding-bottom: 20px;
}
.date-selection {
  //width: 100%;
  width: calc(100% + 10px);
  margin: 0 -5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

li {
  //@include eclipse(39px);
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: #f7f7f7;
  display: table;
  float: left;
  font-size: 9px;
  margin-bottom: 15px;
  text-align: center;
  flex-grow: 0;
  flex-shrink: 0;

  p {
    font-size: 10px;
    color: inherit;
  }

  span {
    color: inherit;
  }

  &.inactive {
    color: $main-disabled;

    &:hover {
      cursor: default;
    }
  }

  &.active {
    cursor: pointer;
    //color: var(--sub-color);
    background-color: white;
    font-weight: 500;
    box-shadow: var(--default-shadow);

    &:hover {
      //      box-shadow: rgba(0, 0, 0, 0.25) 0 4px 15px 0px;
      box-shadow: var(--default-shadow-hover);
      transition: 0.3s box-shadow;
    }

    &.selected {
      cursor: default;
      background-color: var(--selected-color);

      &:hover {
        box-shadow: var(--default-shadow);
      }
    }
  }

  div {
    display: table-cell;
    vertical-align: middle;
  }

  .text {
    font-size: 12px;
    line-height: 13px;
  }

  .date {
    line-height: 17px;

    .day {
      font-size: 10px;
      display: block;
      margin-bottom: -1px;

      text-transform: capitalize;
    }
    .nr {
      font-size: 20px;
      //font-weight: 600;
    }
  }
}
.spoed-holder {
  padding: 5px 0px;
}

.spoed-text {
  padding-top: 10px;
  padding-left: 10px;
}

.ps-text {
  padding-top: 15px;

  &.ps-only {
    padding-top: 0;
    .title {
      font-weight: 600;
    }
  }

  span {
    list-style: normal;
  }
}

.title {
  font-weight: 500;
  padding-bottom: 5px;
}

@media only screen and (max-width: 619px) {
  .list-holder {
    margin-bottom: 20px;
  }

  .date-selection {
    gap: 10px;
    justify-content: start;
  }
}
</style>
